import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated - [fabric-deprecated] - Use SmsNotificationSettingsService from app-account mfe instead
 */
export class SmsNotificationSettingsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getEndpoint(): string {
		return this.configService.get(
			(x) => x.common.smsNotificationSettings.endpoints!.smsNotifications,
			"v1/currentcustomer/notifications"
		);
	}
}
